const fireTrackingEvent = (event, data) => {
    var _a;
    if ((_a = window.tracking) === null || _a === void 0 ? void 0 : _a.track) {
        window.tracking.track(event, data);
    }
    else {
        window.addEventListener("trackingReady", () => {
            var _a;
            if ((_a = window.tracking) === null || _a === void 0 ? void 0 : _a.track) {
                window.tracking.track(event, data);
            }
        });
    }
};

export { fireTrackingEvent };
//# sourceMappingURL=fire-tracking-event.js.map
